webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(140),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

module.exports = {"author":"Mapbox","name":"mapbox.js","description":"Mapbox plugin for Leaflet","version":"3.3.1","homepage":"http://mapbox.com/","engines":{"node":">=10"},"repository":{"type":"git","url":"git://github.com/mapbox/mapbox.js.git"},"main":"src/index.js","files":["dist","src","*.md"],"dependencies":{"@mapbox/corslite":"0.0.7","@mapbox/sanitize-caja":"^0.1.4","leaflet":"1.4.0","mustache":"3.0.1"},"scripts":{"test":"eslint src && phantomjs node_modules/mocha-phantomjs-core/mocha-phantomjs-core.js test/index.html && mocha test/docs.js","prepublishOnly":"npm run build","build":"make"},"license":"BSD-3-Clause","devDependencies":{"browserify":"^16.5.0","clean-css-cli":"^4.3.0","eslint":"^6.8.0","expect.js":"0.3.1","happen":"0.3.2","marked":"^0.8.0","minifyify":"^7.3.5","minimist":"1.2.0","mocha":"^7.0.1","mocha-phantomjs-core":"2.1.2","phantomjs-prebuilt":"2.1.16","sinon":"7.2.4"},"optionalDependencies":{}}

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(72);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var debug = "production" !== 'production';

var metrics = {
  'FCM': [],
  'TCM': [],
  'HCM': []
};

for (var i = 0; i < self.metrics.length; i++) {
  metrics[self.metrics[i].name] = self.metrics[i].metrics;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: {
    selectedMetricCategory: null,
    selectionBoxMode: 'Communities',
    categories: [{
      'name': 'FCM',
      'display': 'Financial Capacity Metrics',
      'description': 'Developing and implementing energy projects that will make communities less dependent on imported fuels is expensive, even if projects have significant public financing. Metrics in this category focus on the existence of capital as well as local costs of doing business.',
      'id': 1,
      'showDetails': false
    }, {
      'name': 'HCM',
      'display': 'Human Capacity Metrics',
      'description': 'Metrics in this category focus on the skills people need to develop and implement projects as well as whether there are community members with the skills to maintain projects – to ensure they can be sustained over the long term.',
      'id': 2,
      'showDetails': false
    }, {
      'name': 'TCM',
      'display': 'Technical Capacity Metrics',
      'description': 'Communities need access to technical information to help them design energy systems that require less imported fuel. Metrics in this category focus on information on current energy use (for electricity, transportation, and heating or cooling) and basic community infrastructure.',
      'id': 3,
      'showDetails': false
    }],
    communityList: self.aggregated_scores,
    communityMetrics: {},
    metrics: metrics,
    pendingCommunities: [],
    AEAEnergyRegions: self.aea_energy_regions,
    CensusAreas: self.census_areas,
    selectFilterText: ''
  },
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  mutations: {
    metricCategory: function metricCategory(state, newCategory) {
      state.selectedMetricCategory = newCategory;
    },
    metricCategoryDetails: function metricCategoryDetails(state, category) {
      state.categories[state.categories.indexOf(category)].showDetails = !category.showDetails;
    },
    communitySelected: function communitySelected(state, payload) {
      state.communityList[payload.index].selected = payload.selected;
    },
    communityCheckbox: function communityCheckbox(state, payload) {
      for (var _i = 0; _i < state.communityList.length; _i++) {
        if (state.communityList[_i].name === payload.community.name) {
          state.communityList[_i].selected = !payload.community.selected;
        }
      }
    },
    clearSelectedCommunities: function clearSelectedCommunities(state) {
      var cl = state.communityList;
      for (var _i2 = 0; _i2 < cl.length; _i2++) {
        cl[_i2].selected = false;
      }
      state.communityList = cl;
    },
    saveCommunityMetrics: function saveCommunityMetrics(state, payload) {
      for (var communityName in payload.metrics) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.communityMetrics, communityName, payload.metrics[communityName]);
      }
    },
    queueCommunity: function queueCommunity(state, payload) {
      state.pendingCommunities.push(payload.community);
    },
    clearCommunityQueue: function clearCommunityQueue(state) {
      state.pendingCommunities = [];
    },
    communitySelectionModeChange: function communitySelectionModeChange(state, payload) {
      state.selectionBoxMode = payload.mode;
    },
    aeaEnergyRegionSelection: function aeaEnergyRegionSelection(state, payload) {
      for (var _i3 = 0; _i3 < state.communityList.length; _i3++) {
        if (state.communityList[_i3].aea_energy_region === payload.regionID) {
          state.communityList[_i3].selected = payload.selected;
        }
      }
    },
    censusAreaSelection: function censusAreaSelection(state, payload) {
      for (var _i4 = 0; _i4 < state.communityList.length; _i4++) {
        if (state.communityList[_i4].census_area === payload.censusAreaID) {
          state.communityList[_i4].selected = payload.selected;
        }
      }
    },
    selectFilterText: function selectFilterText(state, payload) {
      state.selectFilterText = payload.value;
    }
  },
  strict: debug
}));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MetricSelector_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MetricSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MetricSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommunityMap_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommunityMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CommunityMap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResultsList_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResultsList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ResultsList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CommunitySelectBox_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CommunitySelectBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CommunitySelectBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StickyLegend_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StickyLegend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StickyLegend_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    CommunitySelectBox: __WEBPACK_IMPORTED_MODULE_3__components_CommunitySelectBox_vue___default.a,
    CommunityMap: __WEBPACK_IMPORTED_MODULE_1__components_CommunityMap_vue___default.a,
    MetricSelector: __WEBPACK_IMPORTED_MODULE_0__components_MetricSelector_vue___default.a,
    ResultsList: __WEBPACK_IMPORTED_MODULE_2__components_ResultsList_vue___default.a,
    StickyLegend: __WEBPACK_IMPORTED_MODULE_4__components_StickyLegend_vue___default.a
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aeaenergyregion-list',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['selectedMetricCategory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['AEAEnergyRegionsForSelect', 'AEAEnergyRegionChecked'])),
  methods: {
    checkboxClick: function checkboxClick(id) {
      this.$store.commit({
        type: 'aeaEnergyRegionSelection',
        regionID: id,
        selected: !this.AEAEnergyRegionChecked(id)
      });

      this.$store.dispatch('getMetricsForAEAEnergyRegion', id);
    },
    clearSelection: function clearSelection() {
      this.$store.commit({
        type: 'clearSelectedCommunities'
      });
    }
  },
  components: {
    DataAvailabilityIndicator: __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue___default.a
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'censusarea-list',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['selectedMetricCategory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['CensusAreasForSelect', 'CensusAreaChecked'])),
  methods: {
    checkboxClick: function checkboxClick(id) {
      this.$store.commit({
        type: 'censusAreaSelection',
        censusAreaID: id,
        selected: !this.CensusAreaChecked(id)
      });

      this.$store.dispatch('getMetricsForCensusArea', id);
    },
    clearSelection: function clearSelection() {
      this.$store.commit({
        type: 'clearSelectedCommunities'
      });
    }
  },
  components: {
    DataAvailabilityIndicator: __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue___default.a
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'community-list',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['communityList', 'selectedMetricCategory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['communitiesForSelect'])),
  methods: {
    checkboxClick: function checkboxClick(community) {
      if (!community.selected) {
        this.$store.dispatch('getMetricsForCommunity', community);
      }

      this.$store.commit({
        type: 'communityCheckbox',
        community: community
      });
    },
    clearSelection: function clearSelection() {
      this.$store.commit({
        type: 'clearSelectedCommunities'
      });
    }
  },
  components: {
    DataAvailabilityIndicator: __WEBPACK_IMPORTED_MODULE_2__DataAvailabilityIndicator_vue___default.a
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mapbox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'community-map',
  data: function data() {
    return {
      map: null,
      markers: { 'FCM': {}, 'TCM': {}, 'HCM': {} },
      mapCategory: null,
      lowData: '',
      mediumData: '',
      highData: ''
    };
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['communityList', 'categories', 'selectedMetricCategory']),
  mounted: function mounted() {
    var southWest = __WEBPACK_IMPORTED_MODULE_1_mapbox_js__["latLng"](50.695793, -188.291053);
    var northEast = __WEBPACK_IMPORTED_MODULE_1_mapbox_js__["latLng"](71.484692, -129.218604);
    var bounds = __WEBPACK_IMPORTED_MODULE_1_mapbox_js__["latLngBounds"](southWest, northEast);
    __WEBPACK_IMPORTED_MODULE_1_mapbox_js__["mapbox"].accessToken = 'pk.eyJ1Ijoia2JvcmFzaCIsImEiOiJjajB6cW0wYTAwMm05MzJxZHBnZmxmZjNhIn0.4LSGfOYP20gxv--B5ds9qw';
    this.map = __WEBPACK_IMPORTED_MODULE_1_mapbox_js__["mapbox"].map('map', null, {
      maxBounds: bounds,
      minZoom: 4
    }).setView([63.23, -151.57], 4).addLayer(__WEBPACK_IMPORTED_MODULE_1_mapbox_js__["mapbox"].styleLayer('mapbox://styles/mapbox/outdoors-v11'));

    this.lowData = '<svg width="20" height="20" v-if="lowData">\n      <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />\n    </svg>';

    this.mediumData = '<svg width="20" height="20" v-else-if="mediumData">\n      <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />\n      <path d="M 17 10 A 1 1 1 0 1 3 10" fill="black" />\n    </svg>';

    this.highData = '<svg width="20" height="20" v-else-if="goodData">\n      <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />\n      <circle cx="10" cy="10" r="6" stroke-width="1" stroke="black" fill="black" />\n    </svg>';

    this.initializeMarkers();
    this.redrawMap();
  },
  watch: {
    selectedMetricCategory: function selectedMetricCategory() {
      this.redrawMap();
    },
    communityList: {
      handler: function handler() {
        this.redrawMap();
      },
      deep: true
    }
  },
  methods: {
    initializeMarkers: function initializeMarkers() {
      var _this = this;

      var self = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.categories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var category = _step.value;

          var _loop = function _loop(i) {
            var community = _this.communityList[i];

            var svg = null;
            switch (parseInt(community[category.name])) {
              case 1:
                svg = _this.lowData;
                break;
              case 2:
                svg = _this.mediumData;
                break;
              case 3:
                svg = _this.highData;
            }

            var icon = __WEBPACK_IMPORTED_MODULE_1_mapbox_js__["divIcon"]({
              className: 'communityMarkerNotSelected',
              html: svg,
              iconSize: null,
              iconAnchor: null
            });

            var newMarker = __WEBPACK_IMPORTED_MODULE_1_mapbox_js__["marker"]([community.latitude, community.longitude], {
              icon: icon,
              title: community.name
            }).on('click', function () {
              self.communityClicked(i, community);
            }).on('mouseover', function () {
              this.openTooltip();
            }).on('mouseout', function () {
              this.closeTooltip();
            }).bindTooltip(community.name);

            _this.markers[category.name][community.name] = newMarker;
          };

          for (var i = 0; i < this.communityList.length; i++) {
            _loop(i);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    redrawMap: function redrawMap() {
      if (this.selectedMetricCategory === null) {
        return;
      }

      var redrawAllCommunities = false;

      if (this.mapCategory === null) {
        redrawAllCommunities = true;
      } else if (this.mapCategory.name !== this.selectedMetricCategory.name) {
        for (var communityName in this.markers[this.mapCategory.name]) {
          this.map.removeLayer(this.markers[this.mapCategory.name][communityName]);
        }
        redrawAllCommunities = true;
      }

      for (var i = 0; i < this.communityList.length; i++) {
        var marker = this.markers[this.selectedMetricCategory.name][this.communityList[i].name];
        var desiredClass = this.communityList[i].selected ? 'communityMarkerSelected' : 'communityMarkerNotSelected';

        if (redrawAllCommunities === true || marker.options.icon.options.className !== desiredClass) {
          if (!redrawAllCommunities) {
            this.map.removeLayer(marker);
          }
          marker.options.icon.options.className = desiredClass;
          marker.addTo(this.map);
          this.markers[this.selectedMetricCategory.name][this.communityList[i].name] = marker;
        }
      }

      this.mapCategory = this.selectedMetricCategory;
    },
    communityClicked: function communityClicked(index, community) {
      if (!community.selected) {
        this.$store.dispatch('getMetricsForCommunity', community);
      }
      this.$store.commit({
        type: 'communitySelected',
        index: index,
        selected: !community.selected
      });
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityList_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CensusAreaList__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CensusAreaList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CensusAreaList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AEAEnergyRegionList__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AEAEnergyRegionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AEAEnergyRegionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectBoxDropdown_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectBoxDropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectBoxDropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'community-select-box',
  data: function data() {
    return {
      filterBoxText: ''
    };
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['selectionBoxMode', 'selectedMetricCategory']),
  methods: {
    modeSelection: function modeSelection(mode) {
      if (this.selectionBoxMode !== mode) {
        this.$store.commit({
          type: 'communitySelectionModeChange',
          mode: mode
        });
      }
    },
    updateFilter: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      this.$store.commit({
        type: 'selectFilterText',
        value: this.filterBoxText.toLowerCase() });
    }, 300)
  },
  components: {
    AeaenergyregionList: __WEBPACK_IMPORTED_MODULE_2__AEAEnergyRegionList___default.a,
    CensusAreaList: __WEBPACK_IMPORTED_MODULE_1__CensusAreaList___default.a,
    CommunityList: __WEBPACK_IMPORTED_MODULE_0__CommunityList_vue___default.a,
    SelectBoxDropdown: __WEBPACK_IMPORTED_MODULE_3__SelectBoxDropdown_vue___default.a
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'data-availability-indicator',
  props: ['score'],
  computed: {
    'notApplicable': function notApplicable() {
      return this.score === 0 || this.score === "0";
    },
    'lowData': function lowData() {
      return this.score === 1 || this.score === "1";
    },
    'mediumData': function mediumData() {
      return this.score === 2 || this.score === "2";
    },
    'goodData': function goodData() {
      return this.score === 3 || this.score === "3";
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'metric-modal'
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'metric-selector',
  data: function data() {
    return {
      blueCard: 'blue',
      greyCard: 'grey',
      FCMDetails: false,
      TCMDetails: false,
      HCMDetails: false
    };
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])(['selectedMetricCategory', 'categories']),
  methods: {
    selectCategory: function selectCategory(category) {
      this.$store.commit('metricCategory', category);
    },
    categoryDetailsClick: function categoryDetailsClick(category) {
      this.$store.commit('metricCategoryDetails', category);
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DataAvailabilityIndicator_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DataAvailabilityIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DataAvailabilityIndicator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MetricModal_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MetricModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MetricModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Materialize__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Materialize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_Materialize__);








var jQuery = __webpack_require__(54);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'results-list',
  data: function data() {
    return {
      metadataCommunity: null,
      metadataMetric: null,
      metadataCommunityMetric: null,
      contributeCommunity: null,
      contributeError: false,
      contributeErrorText: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['selectedMetricCategory', 'communityList', 'communityMetrics', 'metrics']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['selectedCommunitiesCount', 'selectedCommunities', 'currentMetricLabels', 'pendingCommunities', 'communityBy'])),
  mounted: function mounted() {
    jQuery('#metadata-modal').modal();
    jQuery('#contribute-data-modal').modal();
  },
  methods: {
    indicatorClick: function indicatorClick(metric, community, communityMetric) {
      this.metadataCommunity = community;
      this.metadataMetric = metric;
      this.metadataCommunityMetric = communityMetric;
      jQuery('#metadata-modal').modal('open');
    },
    contributeDataClick: function contributeDataClick(community) {
      this.contributeCommunity = community;
      jQuery('#contribute-data-modal').modal('open');
    },
    submitContribute: function submitContribute() {
      var metricNames = jQuery.map(jQuery('#contribute-data-modal input:checkbox:checked'), function (item, i) {
        return item.id.split('_')[2];
      });

      var name = jQuery('#contributeName').val();
      var email = jQuery('#contributeEmail').val();
      var other = jQuery('#otherData').val();
      var form_data = {
        metrics: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(metricNames),
        name: name,
        community: this.contributeCommunity.name,
        email: email,
        other: other
      };

      jQuery.ajax({
        "dataType": 'json',
        "type": "POST",
        "url": "/community_metric_explorer/data_submission/",
        "data": form_data,
        "success": this.handleContributeResponse,
        "fail": this.handleContributeError
      });
    },
    handleContributeError: function handleContributeError() {
      this.contributeError = true;
      this.contributeErrorText = 'A server error was encountered. Please try again later.';
      __WEBPACK_IMPORTED_MODULE_5_Materialize___default.a.toast('There was an error during your submission.', 5000);
    },
    handleContributeResponse: function handleContributeResponse(data) {
      if (data.send_error) {
        this.contributeError = data.send_error;
        this.contributeErrorText = data.error_message;
        __WEBPACK_IMPORTED_MODULE_5_Materialize___default.a.toast('There was an error during your submission.', 5000);
      } else {
        __WEBPACK_IMPORTED_MODULE_5_Materialize___default.a.toast('Thanks for your submission!', 5000);
        jQuery('#contribute-data-modal').modal('close');
        jQuery('#contribute-data-modal input:checkbox').prop('checked', false);
        jQuery('#otherData').val('');
        this.contributeError = false;
      }
    }
  },
  components: {
    DataAvailabilityIndicator: __WEBPACK_IMPORTED_MODULE_3__DataAvailabilityIndicator_vue___default.a,
    MetricModal: __WEBPACK_IMPORTED_MODULE_4__MetricModal_vue___default.a
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'select-box-dropdown',
  data: function data() {
    return {
      dropdownDisplayed: false
    };
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])(['selectionBoxMode']),
  methods: {
    dropClick: function dropClick() {
      this.dropdownDisplayed = !this.dropdownDisplayed;
    },
    modeSelection: function modeSelection(mode) {
      if (this.selectionBoxMode !== mode) {
        this.$store.commit({
          type: 'communitySelectionModeChange',
          mode: mode
        });
      }
      this.dropdownDisplayed = false;
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataAvailabilityIndicator_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataAvailabilityIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataAvailabilityIndicator_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sticky-legend',
  data: function data() {
    return {};
  },
  components: {
    DataAvailabilityIndicator: __WEBPACK_IMPORTED_MODULE_0__DataAvailabilityIndicator_vue___default.a
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(55);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],

  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMetricsForCommunity", function() { return getMetricsForCommunity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMetricsForCensusArea", function() { return getMetricsForCensusArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMetricsForAEAEnergyRegion", function() { return getMetricsForAEAEnergyRegion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);


var jQuery = __webpack_require__(54);

var _state = null;
var _commit = null;

var getMetricsForCommunities = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
  var state = _state;
  var commit = _commit;

  var pendingCommunities = state.pendingCommunities;
  commit('clearCommunityQueue');

  pendingCommunities = pendingCommunities.map(function (community) {
    return community.name;
  });

  jQuery.getJSON('/community_metrics/', { 'communities': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(pendingCommunities) }, function (communityMetrics) {
    var metrics = {};
    for (var i = 0; i < communityMetrics.length; i++) {
      var cm = communityMetrics[i];
      if (!(communityMetrics[i].community__name in metrics)) {
        metrics[cm.community__name] = { 'FCM': {}, 'TCM': {}, 'HCM': {} };
      }

      metrics[cm.community__name][cm.metric__metric_category__name][cm.metric__name] = {
        'dataset_link': cm.dataset_link,
        'score': cm.score,
        'data_availability_range': cm.data_availability_range
      };
    }
    commit({
      type: 'saveCommunityMetrics',
      metrics: metrics
    });
  });
}, 750);

var getMetricsForCommunity = function getMetricsForCommunity(_ref, community) {
  var commit = _ref.commit,
      state = _ref.state;

  if (!(community.name in state.communityMetrics)) {
    commit({
      type: 'queueCommunity',
      community: community
    });
    _commit = commit;
    _state = state;

    getMetricsForCommunities();
  }
};

var getMetricsForCensusArea = function getMetricsForCensusArea(_ref2, censusAreaID) {
  var commit = _ref2.commit,
      state = _ref2.state;

  var communities = state.communityList.filter(function (community) {
    return community.census_area === censusAreaID;
  });
  for (var i = 0; i < communities.length; i++) {
    getMetricsForCommunity({ commit: commit, state: state }, communities[i]);
  }
};

var getMetricsForAEAEnergyRegion = function getMetricsForAEAEnergyRegion(_ref3, aeaEnergyRegionID) {
  var commit = _ref3.commit,
      state = _ref3.state;

  var communities = state.communityList.filter(function (community) {
    return community.aea_energy_region === aeaEnergyRegionID;
  });
  for (var i = 0; i < communities.length; i++) {
    getMetricsForCommunity({ commit: commit, state: state }, communities[i]);
  }
};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "communitiesForSelect", function() { return communitiesForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedCommunities", function() { return selectedCommunities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedCommunitiesCount", function() { return selectedCommunitiesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentMetricLabels", function() { return currentMetricLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "metricsForCommunoty", function() { return metricsForCommunoty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pendingCommunities", function() { return pendingCommunities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AEAEnergyRegionsWithScore", function() { return AEAEnergyRegionsWithScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AEAEnergyRegionsForSelect", function() { return AEAEnergyRegionsForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AEAEnergyRegionChecked", function() { return AEAEnergyRegionChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CensusAreasWithScore", function() { return CensusAreasWithScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CensusAreasForSelect", function() { return CensusAreasForSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CensusAreaChecked", function() { return CensusAreaChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CensusAreaCommunities", function() { return CensusAreaCommunities; });
var communitiesForSelect = function communitiesForSelect(state) {
  if (state.selectFilterText !== '') {
    return state.communityList.filter(function (community) {
      return community.name.toLowerCase().indexOf(state.selectFilterText) >= 0;
    });
  } else {
    return state.communityList;
  }
};

var selectedCommunities = function selectedCommunities(state) {
  return state.communityList.filter(function (community) {
    return community.selected;
  });
};

var selectedCommunitiesCount = function selectedCommunitiesCount(state) {
  var communities = state.communityList.filter(function (community) {
    return community.selected;
  });
  return communities.length;
};

var currentMetricLabels = function currentMetricLabels(state) {
  if (state.selectedMetricCategory === null) {
    return [];
  } else {
    return state.metrics[state.selectedMetricCategory.name];
  }
};

var metricsForCommunoty = function metricsForCommunoty(state, community) {
  return state.communityMetrics[community.name][state.selectedMetricCategory.name];
};

var pendingCommunities = function pendingCommunities(state) {
  return state.pendingCommunities.length > 0;
};

var AEAEnergyRegionsWithScore = function AEAEnergyRegionsWithScore(state) {
  var currentMetricCategory = state.selectedMetricCategory;
  var regions = state.AEAEnergyRegions;

  var _loop = function _loop(i) {
    var communities = state.communityList.filter(function (community) {
      return community.aea_energy_region === regions[i].id;
    });
    var count = communities.length;
    var total = communities.reduce(function (prev, next) {
      return prev + parseInt(next[currentMetricCategory.name]);
    }, 0);
    regions[i].score = Math.round(total / (count + 0.0));
  };

  for (var i = 0; i < regions.length; i++) {
    _loop(i);
  }
  return regions;
};

var AEAEnergyRegionsForSelect = function AEAEnergyRegionsForSelect(state) {
  var regions = AEAEnergyRegionsWithScore(state);
  if (state.selectFilterText !== '') {
    return regions.filter(function (region) {
      return region.name.toLowerCase().indexOf(state.selectFilterText) >= 0;
    });
  } else {
    return regions;
  }
};

var AEAEnergyRegionChecked = function AEAEnergyRegionChecked(state) {
  return function (regionID) {
    return state.communityList.filter(function (community) {
      return community.aea_energy_region === regionID;
    }).reduce(function (prev, next) {
      return prev && next.selected;
    }, true);
  };
};

var CensusAreasWithScore = function CensusAreasWithScore(state) {
  var currentMetricCategory = state.selectedMetricCategory;
  var CensusAreas = state.CensusAreas;

  var _loop2 = function _loop2(i) {
    var communities = state.communityList.filter(function (community) {
      return community.census_area === CensusAreas[i].id;
    });
    var count = communities.length;
    var total = communities.reduce(function (prev, next) {
      return prev + parseInt(next[currentMetricCategory.name]);
    }, 0);
    CensusAreas[i].score = Math.round(total / (count + 0.0));
  };

  for (var i = 0; i < CensusAreas.length; i++) {
    _loop2(i);
  }
  return CensusAreas;
};

var CensusAreasForSelect = function CensusAreasForSelect(state) {
  var areas = CensusAreasWithScore(state);
  if (state.selectFilterText !== '') {
    return areas.filter(function (area) {
      return area.name.toLowerCase().indexOf(state.selectFilterText) >= 0;
    });
  } else {
    return areas;
  }
};

var CensusAreaChecked = function CensusAreaChecked(state) {
  return function (censusAreasID) {
    return state.communityList.filter(function (community) {
      return community.census_area === censusAreasID;
    }).reduce(function (prev, next) {
      return prev && next.selected;
    }, true);
  };
};

var CensusAreaCommunities = function CensusAreaCommunities(state) {
  return function (censusAreaID) {
    return state.communityList.filter(function (community) {
      return community.census_area === censusAreaID;
    });
  };
};

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(117)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(151),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(114)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(148),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(142),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(115)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(143),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(113)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(144),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(116)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(141),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lowData) ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "9",
      "stroke-width": "1",
      "stroke": "black",
      "fill": "white"
    }
  })]) : (_vm.mediumData) ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "9",
      "stroke-width": "1",
      "stroke": "black",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M 17 10 A 1 1 1 0 1 3 10",
      "fill": "black"
    }
  })]) : (_vm.goodData) ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "9",
      "stroke-width": "1",
      "stroke": "black",
      "fill": "white"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "6",
      "stroke-width": "1",
      "stroke": "black",
      "fill": "black"
    }
  })]) : (_vm.notApplicable) ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20"
    }
  }, [_c('line', {
    attrs: {
      "x1": "1",
      "x2": "19",
      "y1": "10",
      "y2": "10",
      "stroke-width": "3",
      "stroke": "black"
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sticky-legend"
  }, [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v("Legend")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('data-availability-indicator', {
    attrs: {
      "score": 3
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("Lots of data available")])]), _vm._v(" "), _c('tr', [_c('td', [_c('data-availability-indicator', {
    attrs: {
      "score": 2
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("Some data available")])]), _vm._v(" "), _c('tr', [_c('td', [_c('data-availability-indicator', {
    attrs: {
      "score": 1
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("Little to no data available")])]), _vm._v(" "), _c('tr', [_c('td', [_c('data-availability-indicator', {
    attrs: {
      "score": 0
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("Metric does not exist for this community")])])])])])
},staticRenderFns: []}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "striped"
  }, [_c('thead', [_c('th', [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Clear Selection"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("clear")])]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Community Name")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Data Category")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Data Availability")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Community Data Summary")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communitiesForSelect), function(community, index) {
    return (_vm.selectedMetricCategory !== null) ? _c('tr', [_c('td', {
      staticClass: "checkbox_container"
    }, [_c('input', {
      staticClass: "filled-in",
      attrs: {
        "id": 'com_' + index,
        "type": "checkbox"
      },
      domProps: {
        "checked": community.selected
      },
      on: {
        "click": function($event) {
          return _vm.checkboxClick(community)
        }
      }
    }), _c('label', {
      attrs: {
        "for": 'com_' + index
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "center-align"
    }, [_vm._v(_vm._s(community.name))]), _vm._v(" "), _c('td', {
      staticClass: "center-align"
    }, [_vm._v(_vm._s(_vm.selectedMetricCategory.display.split(' ')[0]))]), _vm._v(" "), _c('td', {
      staticClass: "center-align"
    }, [_c('data-availability-indicator', {
      attrs: {
        "score": community[_vm.selectedMetricCategory.name]
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "center-align"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": '/community-data-summary/' + community.gnis_feature_id + '/'
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_forward")])])])]) : _vm._e()
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community_select"
  }, [(_vm.selectedMetricCategory == null) ? _c('h5', [_vm._v(_vm._s("Select a metric above to display communities"))]) : _c('div', {
    staticStyle: {
      "height": "inherit"
    }
  }, [_c('div', {
    staticClass: "selection_mode_options"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.selectionBoxMode))]), _vm._v(" "), _c('select-box-dropdown', {
    staticClass: "right",
    staticStyle: {
      "display": "inline-block",
      "margin-top": "1rem",
      "margin-right": ".5rem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "selection_listing"
  }, [(_vm.selectionBoxMode === 'Communities') ? _c('community-list') : _vm._e(), _vm._v(" "), (_vm.selectionBoxMode === 'AEA Energy Regions') ? _c('aeaenergyregion-list') : _vm._e(), _vm._v(" "), (_vm.selectionBoxMode === 'Census Areas') ? _c('census-area-list') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "selection_footer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterBoxText),
      expression: "filterBoxText"
    }],
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "placeholder": "Search table..."
    },
    domProps: {
      "value": (_vm.filterBoxText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterBoxText = $event.target.value
      }, _vm.updateFilter]
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.categories), function(category) {
    return _c('div', {
      staticClass: "col s4"
    }, [_c('div', {
      staticClass: "card darken-1",
      class: [(_vm.selectedMetricCategory !== null && category.id == _vm.selectedMetricCategory.id) ? _vm.blueCard : _vm.greyCard]
    }, [_c('div', {
      staticClass: "card-content white-text"
    }, [_c('span', {
      staticClass: "card-title center-align"
    }, [_vm._v(_vm._s(category.display))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (category.showDetails),
        expression: "category.showDetails"
      }]
    }, [_vm._v(_vm._s(category.description))])]), _vm._v(" "), _c('div', {
      staticClass: "card-action center-align"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.categoryDetailsClick(category)
        }
      }
    }, [(!category.showDetails) ? _c('span', [_vm._v("Show Details")]) : _c('span', [_vm._v("Hide Details")])]), _vm._v(" "), _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.selectCategory(category)
        }
      }
    }, [_vm._v("Select")])])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select_box_dropdown_container"
  }, [_c('div', {
    staticClass: "select_downdown_icon",
    on: {
      "click": _vm.dropClick
    }
  }, [_vm._v("Table Display Options")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownDisplayed),
      expression: "dropdownDisplayed"
    }],
    staticClass: "select_box_dropdown"
  }, [_c('li', {
    staticClass: "select_box_dropdown_option",
    class: {
      selection_mode_option_active: _vm.selectionBoxMode === 'Communities'
    },
    on: {
      "click": function($event) {
        return _vm.modeSelection('Communities')
      }
    }
  }, [_vm._v("Communities")]), _vm._v(" "), _c('li', {
    staticClass: "select_box_dropdown_option",
    class: {
      selection_mode_option_active: _vm.selectionBoxMode === 'AEA Energy Regions'
    },
    on: {
      "click": function($event) {
        return _vm.modeSelection('AEA Energy Regions')
      }
    }
  }, [_vm._v("AEA Energy Regions")]), _vm._v(" "), _c('li', {
    staticClass: "select_box_dropdown_option",
    class: {
      selection_mode_option_active: _vm.selectionBoxMode === 'Census Areas'
    },
    on: {
      "click": function($event) {
        return _vm.modeSelection('Census Areas')
      }
    }
  }, [_vm._v("Census Areas")])])])
},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h2', {
    staticClass: "center-align"
  }, [_vm._v("Community Metric Explorer")]), _vm._v(" "), _c('p', {
    staticClass: "center-align"
  }, [_vm._v("This tool allows users to see whether data is available for evaluating the financial, human, and technical capacity of specific Alaska communities to undertake energy projects.")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s10"
  }, [_vm._m(0), _vm._v(" "), _c('metric-selector'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row community-selection-container"
  }, [_c('div', {
    staticClass: "col l7 s6"
  }, [_c('community-map')], 1), _vm._v(" "), _c('div', {
    staticClass: "col l5 s6"
  }, [_c('community-select-box')], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('results-list')], 1), _vm._v(" "), _c('div', {
    staticClass: "col s2"
  }, [_c('sticky-legend')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v("Step 1: Select a Metric Category")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v("Step 2: Select Communities")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v("Step 3: View Metrics for Communities")])])])
}]}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n            Metadata Header\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n            Metadata Body. Things like quantity of data, data set descriptions, and a link to the data search tool.\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              Close\n            ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "striped"
  }, [_c('thead', [_c('th', [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Clear Selection"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("clear")])]), _vm._v(" "), _c('th', [_vm._v("Census Area")]), _vm._v(" "), _c('th', [_vm._v("Data Category")]), _vm._v(" "), _c('th', [_vm._v("Data Availability")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.CensusAreasForSelect), function(censusArea) {
    return _c('tr', [_c('td', [_c('input', {
      staticClass: "filled-in",
      attrs: {
        "id": 'ca_' + censusArea.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.CensusAreaChecked(censusArea.id)
      },
      on: {
        "click": function($event) {
          return _vm.checkboxClick(censusArea.id)
        }
      }
    }), _c('label', {
      attrs: {
        "for": 'ca_' + censusArea.id
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(censusArea.name))]), _vm._v(" "), _c('td', {
      staticClass: "center_cell"
    }, [_vm._v(_vm._s(_vm.selectedMetricCategory.display.split(' ')[0]))]), _vm._v(" "), _c('td', {
      staticClass: "center_cell"
    }, [_c('data-availability-indicator', {
      attrs: {
        "score": censusArea.score
      }
    })], 1)])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])
}]}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resultsView"
  }, [(_vm.selectedMetricCategory !== null && _vm.selectedCommunitiesCount !== 0) ? _c('div', [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v(_vm._s(_vm.selectedMetricCategory.display) + " for Selected Communities")]), _vm._v(" "), _c('div', {
    staticClass: "sticky_div_table"
  }, [_c('div', {
    staticClass: "metricname_column"
  }, [_c('div', {
    staticClass: "metric_label_header"
  }, [_vm._v("Metric Name")]), _vm._v(" "), _vm._l((_vm.currentMetricLabels), function(metricLabel) {
    return _c('div', {
      staticClass: "metric_label valign-wrapper"
    }, [_vm._v(_vm._s(metricLabel.display_name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "result_rows_container"
  }, [_c('div', {
    staticClass: "rows"
  }, [_c('div', {
    staticClass: "headers"
  }, _vm._l((_vm.selectedCommunities), function(community) {
    return (community.name in _vm.communityMetrics) ? _c('div', [_vm._v(_vm._s(community.name)), _c('i', {
      staticClass: "material-icons contribute-icon",
      attrs: {
        "title": "Contribute Data"
      },
      on: {
        "click": function($event) {
          return _vm.contributeDataClick(community)
        }
      }
    }, [_vm._v("add_circle_outline")])]) : _vm._e()
  }), 0), _vm._v(" "), _vm._l((_vm.currentMetricLabels), function(metricLabel) {
    return _c('div', {
      staticClass: "content-row"
    }, _vm._l((_vm.selectedCommunities), function(community) {
      return (community.name in _vm.communityMetrics) ? _c('div', {
        staticClass: "center-align",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": "Click for Details"
        },
        on: {
          "click": function($event) {
            return _vm.indicatorClick(metricLabel, community, _vm.communityMetrics[community.name][_vm.selectedMetricCategory.name][metricLabel.name])
          }
        }
      }, [_c('data-availability-indicator', {
        attrs: {
          "score": _vm.communityMetrics[community.name][_vm.selectedMetricCategory.name][metricLabel.name].score
        }
      })], 1) : _vm._e()
    }), 0)
  })], 2)])])]) : _c('div', [_c('h5', {
    staticClass: "center-align"
  }, [_vm._v("Select one or more communities above to view metrics")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingCommunities),
      expression: "pendingCommunities"
    }],
    staticClass: "results-overlay center-align"
  }, [_c('h3', [_vm._v("Loading Additional Communities")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal bottom-sheet",
    attrs: {
      "id": "metadata-modal"
    }
  }, [(_vm.metadataCommunity != null) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.metadataMetric.display_name))]), _vm._v(" "), _c('p', [_vm._v("Data Resolution: " + _vm._s(_vm.metadataMetric.data_temporality))]), _vm._v(" "), _c('p', [_vm._v("Data Availability Range: " + _vm._s(_vm.metadataCommunityMetric.data_availability_range))]), _vm._v(" "), _c('p', [_vm._v("Data Format: " + _vm._s(_vm.metadataMetric.available_formats))]), _vm._v(" "), _c('p', [_vm._v("View data set filtered for "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.metadataCommunityMetric.dataset_link
    }
  }, [_vm._v(_vm._s(_vm.metadataCommunity.name))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "contribute-data-modal"
    }
  }, [(_vm.contributeCommunity != null) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('h4', [_vm._v("Contribute Data for " + _vm._s(_vm.contributeCommunity.name))]), _vm._v(" "), _c('p', [_vm._v("Thank you for your interest in contributing data to the Alaska Energy Data Gateway. Please select any of the datasets\n      listed below that you'd like to contribute data towards, or select other and provide some details about your data.")]), _vm._v(" "), _c('p', [_vm._v("An administrator will contact you about your data.")]), _vm._v(" "), _vm._l((_vm.currentMetricLabels), function(metricLabel, index) {
    return _c('ul', {
      attrs: {
        "id": "contribute-data-metric-list"
      }
    }, [_c('input', {
      staticClass: "filled-in",
      attrs: {
        "id": 'metric_' + _vm.selectedMetricCategory.name + '_' + metricLabel.name,
        "type": "checkbox"
      }
    }), _c('label', {
      attrs: {
        "for": 'metric_' + _vm.selectedMetricCategory.name + '_' + metricLabel.name
      }
    }, [_vm._v(_vm._s(metricLabel.display_name))])])
  }), _vm._v(" "), _c('textarea', {
    staticClass: "materialize-textarea",
    attrs: {
      "id": "otherData",
      "name": "other_data_details",
      "placeholder": "Please describe any other data you'd like to contribue."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "contributeName",
      "placeholder": "Your Name..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "contributeEmail",
      "placeholder": "Your email..."
    }
  }), _vm._v(" "), (_vm.contributeError) ? _c('p', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.contributeErrorText))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn waves-effect blue darken-4 left",
    on: {
      "click": _vm.submitContribute
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn modal-action modal-close waves-effect red",
    attrs: {
      "href": "#!"
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper big active"
  }, [_c('div', {
    staticClass: "spinner-layer spinner-blue-only"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "striped"
  }, [_c('thead', [_c('th', [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Clear Selection"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("clear")])]), _vm._v(" "), _c('th', [_vm._v("AEA Energy Region")]), _vm._v(" "), _c('th', [_vm._v("Data Category")]), _vm._v(" "), _c('th', [_vm._v("Data Availability")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.AEAEnergyRegionsForSelect), function(region) {
    return _c('tr', [_c('td', [_c('input', {
      staticClass: "filled-in",
      attrs: {
        "id": 'region_' + region.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.AEAEnergyRegionChecked(region.id)
      },
      on: {
        "click": function($event) {
          return _vm.checkboxClick(region.id)
        }
      }
    }), _c('label', {
      attrs: {
        "for": 'region_' + region.id
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(region.name))]), _vm._v(" "), _c('td', {
      staticClass: "center_cell"
    }, [_vm._v(_vm._s(_vm.selectedMetricCategory.display.split(' ')[0]))]), _vm._v(" "), _c('td', {
      staticClass: "center_cell"
    }, [_c('data-availability-indicator', {
      attrs: {
        "score": region.score
      }
    })], 1)])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports) {

module.exports = Materialize;

/***/ })
],[71]);


// WEBPACK FOOTER //
// community_metric_explorer/js/app.16d7eb24344ff507d47d.js